import script from "./log.vue?vue&type=script&setup=true&lang=js"
export * from "./log.vue?vue&type=script&setup=true&lang=js"

import "./log.vue?vue&type=style&index=0&id=28589f49&lang=less"

const __exports__ = script;

export default __exports__